import { createSlice } from '@reduxjs/toolkit';
import {
  IGetSecureDataRequestTextResponse,
  IGetSecureDataRequestTextVariablesResponse,
} from 'services/connectwise/types';
import { IRequest } from 'services/pod/types';
import { ISecureDataSettings } from 'services/secureDataSharing/types';
import { RootState } from 'store/index';
import {
  ThunkCheckSecureDataRequest,
  ThunkGetSecureDataRequests,
  ThunkGetSecureDataRequestSettings,
  ThunkGetSecureDataRequestText,
  ThunkGetSecureDataRequestTextVariables,
  ThunkGetSecureDataSharing,
} from 'store/secureDataSharing/thunks';

interface IInitialState {
  settings: ISecureDataSettings | undefined;
  requestSettings: ISecureDataSettings | undefined;
  requestText: IGetSecureDataRequestTextResponse[] | undefined;
  textVariables: IGetSecureDataRequestTextVariablesResponse | undefined;
  requests: any[] | undefined;
  checkResult: IRequest | undefined;
  requestsTotalCount: number;
}

const initialState: IInitialState = {
  settings: undefined,
  requestSettings: undefined,
  requestText: undefined,
  textVariables: undefined,
  requests: undefined,
  checkResult: undefined,
  requestsTotalCount: 0,
};

const secureDataSharingSlice = createSlice({
  name: 'secureDataSharing',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(ThunkGetSecureDataSharing.fulfilled, (state, action) => {
      state.settings = action.payload;
    });
    builder.addCase(ThunkGetSecureDataRequestSettings.fulfilled, (state, action) => {
      state.requestSettings = action.payload;
    });
    builder.addCase(ThunkGetSecureDataRequestText.fulfilled, (state, action) => {
      state.requestText = action.payload;
    });
    builder.addCase(ThunkGetSecureDataRequestTextVariables.fulfilled, (state, action) => {
      state.textVariables = action.payload;
    });
    builder.addCase(ThunkGetSecureDataRequests.fulfilled, (state, action) => {
      state.requests = action.payload.data;
      state.requestsTotalCount = action.payload.totalCount;
    });
    builder.addCase(ThunkCheckSecureDataRequest.fulfilled, (state, action) => {
      state.checkResult = action.payload;
    });
  },
});

export default secureDataSharingSlice.reducer;
export const SecureDataSettingsSelector = (state: RootState): ISecureDataSettings | undefined =>
  state.secureDataSharing.settings;

export const SecureDataRequestTextSelector = (
  state: RootState,
): IGetSecureDataRequestTextResponse[] | undefined => state.secureDataSharing.requestText;

export const SecureDataRequestTextVariablesSelector = (
  state: RootState,
): IGetSecureDataRequestTextVariablesResponse | undefined => state.secureDataSharing.textVariables;

export const SecureDataRequestSettingsSelector = (
  state: RootState,
): ISecureDataSettings | undefined => state.secureDataSharing.requestSettings;

export const SecureDataRequestsSelector = (state: RootState): any[] | undefined =>
  state.secureDataSharing.requests;

export const SecureDataCheckResultSelector = (state: RootState): IRequest | undefined =>
  state.secureDataSharing.checkResult;

export const SecureDataRequestsTotalCountSelector = (state: RootState): number =>
  state.secureDataSharing.requestsTotalCount;
